import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEditor, useValue } from "@tldraw/editor";
import {
  useCanRedo,
  useCanUndo,
  useIsInSelectState,
  useUnlockedSelectedShapesCount
} from "../../hooks/menu-hooks.mjs";
import { useCommentingEnabled } from "../../hooks/useCommentingEnabled.mjs";
import { useReadonly } from "../../hooks/useReadonly.mjs";
import { TldrawUiMenuActionItem } from "../primitives/menus/TldrawUiMenuActionItem.mjs";
import { TldrawUiMenuToolItem } from "../primitives/menus/TldrawUiMenuToolItem.mjs";
function DefaultQuickActionsContent() {
  const editor = useEditor();
  const isReadonlyMode = useReadonly();
  const isInAcceptableReadonlyState = useValue(
    "should display quick actions",
    () => editor.isInAny("select", "hand", "zoom"),
    [editor]
  );
  if (isReadonlyMode && !isInAcceptableReadonlyState) return;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(UndoRedoGroup, {}),
    /* @__PURE__ */ jsx(DeleteDuplicateGroup, {}),
    /* @__PURE__ */ jsx(CommentQuickAction, {})
  ] });
}
function DeleteDuplicateGroup() {
  const oneSelected = useUnlockedSelectedShapesCount(1);
  const isInSelectState = useIsInSelectState();
  const selectDependentActionsEnabled = oneSelected && isInSelectState;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(TldrawUiMenuActionItem, { actionId: "delete", disabled: !selectDependentActionsEnabled }),
    /* @__PURE__ */ jsx(TldrawUiMenuActionItem, { actionId: "duplicate", disabled: !selectDependentActionsEnabled })
  ] });
}
function CommentQuickAction() {
  const editor = useEditor();
  const commentingEnabled = useCommentingEnabled();
  const isCommentToolSelected = useValue(
    "is comment tool selected",
    () => editor.getCurrentToolId() === "comment",
    [editor]
  );
  if (!commentingEnabled) return null;
  return /* @__PURE__ */ jsx(TldrawUiMenuToolItem, { toolId: "comment", isSelected: isCommentToolSelected });
}
function UndoRedoGroup() {
  const canUndo = useCanUndo();
  const canRedo = useCanRedo();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(TldrawUiMenuActionItem, { actionId: "undo", disabled: !canUndo }),
    /* @__PURE__ */ jsx(TldrawUiMenuActionItem, { actionId: "redo", disabled: !canRedo })
  ] });
}
export {
  DefaultQuickActionsContent
};
//# sourceMappingURL=DefaultQuickActionsContent.mjs.map
